const data = [
  {
    id: 1,
    category: "Business",
    price: 20,
    title: "Think and Grow Rich",
    img:
      "https://qph.fs.quoracdn.net/main-qimg-82bf4a8f5393f0055e61e1f52a5d3e13-lq",
    total: 1
  },
  {
    id: 2,
    category: "Computers & Tech",
    price: 13,
    title: "Programming in Objective-C 2.0",
    img: "https://images-na.ssl-images-amazon.com/images/I/41M2GuGl44L.jpg",
    total: 1
  },
  {
    id: 3,
    category: "Business",
    price: 42,
    title: "Dont Sweat the Small Stuff",
    img: "https://images-na.ssl-images-amazon.com/images/I/51yoISQV5gL.jpg",
    total: 1
  },
  {
    id: 4,
    category: "Science & Math",
    price: 11,
    title: "The Omnivore Dilemma: A Natural History of Four Meals",
    img:
      "https://img.thriftbooks.com/api/images/l/d07dc11e0c9c2ae3eee3e05344585a3da2a8584b.jpg",
    total: 1
  },
  {
    id: 5,
    category: "Self-help",
    price: 15,
    title: "Alchemist, The",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGzVFqQTtl9R76jRu2xazT4R4QyDwWsjvLtJxK8ptsyAK1tZj4yIAYRxfI7okgUb80mn8&usqp=CAU",
    total: 1
  },
  {
    id: 6,
    category: "Self-help",
    price: 31,
    title: "Living Sober",
    img:
      "https://ebooks.gramedia.com/ebook-covers/47982/image_highres/ID_TGR2019MTH06TGR.jpg",
    total: 1
  }
];

export default data;
